"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostOrderChangeStatus = void 0;
const Base_1 = require("./Base");
exports.PostOrderChangeStatus = {
    url: Base_1.URL_BASE + "/OrderChangeStatus",
    method: "POST",
    secure: true
};
//# sourceMappingURL=PostOrderChangeStatus.js.map